'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Copyright 2019 Adobe Inc. All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  This file is licensed to you under the Apache License, Version 2.0 (the "License");
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  you may not use this file except in compliance with the License. You may obtain a copy
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  of the License at http://www.apache.org/licenses/LICENSE-2.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Unless required by applicable law or agreed to in writing, software distributed under
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  OF ANY KIND, either express or implied. See the License for the specific language
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  governing permissions and limitations under the License.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     */

var _GlobalData = require('./GlobalData');

var _GlobalData2 = _interopRequireDefault(_GlobalData);

var _WAMConstants = require('../../wam/constants/WAMConstants');

var _ingestReact = require('@cchome/ingest-react');

var _ingestReact2 = _interopRequireDefault(_ingestReact);

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

var _CommonUtil = require('./CommonUtil');

var _CommonUtil2 = _interopRequireDefault(_CommonUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AnalyticsUtil = function () {
	function AnalyticsUtil() {
		_classCallCheck(this, AnalyticsUtil);

		if (this.instance) {
			return this.instance;
		}
		this.instance = this;
	}

	// Singleton


	_createClass(AnalyticsUtil, [{
		key: 'getIngestObject',
		value: function getIngestObject(env) {
			var initObj = {};
			initObj.xApiKey = 'cchome-web-service';
			initObj.apiKey = 'cchome-web-service';
			initObj.clientId = 'CCHomeWeb1';
			initObj.project = 'cchome-web-service';
			initObj.source = 'CCHome';
			initObj.environment = env || _GlobalData2.default.env;
			initObj.rsid = 'adbem-cchome-dev';
			if (initObj.environment === 'prod') {
				initObj.rsid = 'adbem-cchome-prod';
			}
			this.ingest = new _ingestReact2.default(initObj);
			this.ingest.initializeDefaultData();
			return this.ingest;
		}

		/**
   * [sendToIngest Post to ingest]
   * @return {[none]}
   */

	}, {
		key: 'sendToIngest',
		value: function sendToIngest() {
			if (typeof this.ingest.metricsCollection !== 'undefined' && this.ingest.metricsCollection.length) {
				this.ingest.sendToIngest().catch(function (err) {
					console.error(err);
				});
			}
		}

		/**
   * [addToCollection A utility method to set multiple values at once]
   * @param  {[object of key/value pairs]} dataObject [events]
   * @return {[none]}
   */

	}, {
		key: 'addToCollection',
		value: function addToCollection(dataObject) {
			var _this = this;

			Object.keys(dataObject).forEach(function (key) {
				var value = dataObject[key];
				if (value !== null && typeof value !== 'undefined') {
					switch (key) {
						case 'setEventSubcategory':
							_this.ingest.setDataValue('event', 'subcategory', value);
							break;
						case 'setEventValue':
							_this.ingest.setDataValue('event', 'value', value);
							break;
						case 'setEventType':
							_this.ingest.setDataValue('event', 'type', value);
							break;
						case 'setEventSubtype':
							_this.ingest.setDataValue('event', 'subtype', value);
							break;
						case 'setEventCount':
							_this.ingest.setDataValue('event', 'count', value);
							break;
						case 'setEventOffline':
							_this.ingest.setDataValue('event', 'offline', value);
							break;
						case 'setEventContextGUID':
							_this.ingest.setDataValue('event', 'context_guid', value);
							break;
						case 'setEventGUID':
							_this.ingest.setDataValue('event', 'guid', value);
							break;
						case 'setEventContextSequence':
							_this.ingest.setDataValue('event', 'context_sequence', value);
							break;
						case 'setContentID':
							_this.ingest.setDataValue('content', 'id', value);
							break;
						case 'setContentName':
							{
								// Splunk seems to be having problems with spaces
								var newVal = _this.replaceSpaces(value);
								_this.ingest.setDataValue('content', 'name', newVal);
							}
							break;
						case 'setContentType':
							_this.ingest.setDataValue('content', 'type', value);
							break;
						case 'setContentCategory':
							_this.ingest.setDataValue('content', 'category', value);
							break;
						case 'setContentAction':
							_this.ingest.setDataValue('content', 'action', value);
							break;
						case 'setContentAuthor':
							_this.ingest.setDataValue('content', 'author', value);
							break;
						case 'setContentStatus':
							_this.ingest.setDataValue('content', 'status', value);
							break;
						case 'setUIFilter':
							_this.ingest.setDataValue('ui', 'filter', value);
							break;
						case 'setUIViewType':
							_this.ingest.setDataValue('ui', 'view_type', value);
							break;
						case 'setEnvComName':
							_this.ingest.setDataValue('env', 'com.name', value);
							break;
						case 'setEnvironmentServiceName':
							_this.ingest.setDataValue('env', 'svc.name', value);
							break;
						case 'setComponentVersion':
							_this.ingest.setDataValue('env', 'com.version', value);
							break;
						case 'setFrameworkName':
							_this.ingest.setDataValue('env', 'fw.name', value);
							break;
						case 'setErrorCode':
							_this.ingest.setDataValue('event', 'error_code', value);
							break;
						case 'setErrorType':
							_this.ingest.setDataValue('event', 'error_type', value);
							break;
						case 'setErrorDesc':
							_this.ingest.setDataValue('event', 'error_desc', value);
							break;
						case 'setSearchKeyword':
							_this.ingest.setDataValue('event', 'search_keyword', value);
							break;
						case 'setContentExtension':
							// Sends the latest version of the app being downloaded
							_this.ingest.setDataValue('content', 'extension', value);
							break;
						case 'setExpCampaignID':
							_this.ingest.setDataValue('exp', 'campaign_id', value);
							break;
						case 'setExpVariationID':
							_this.ingest.setDataValue('exp', 'variation_id', value);
							break;
						case 'setSourceName':
							_this.ingest.setDataValue('source', 'name', value);
							break;
						case 'setSourceVersion':
							_this.ingest.setDataValue('source', 'version', value);
							break;
						case 'setSourceClientId':
							_this.ingest.setDataValue('source', 'client_id', value);
							break;
						case 'setSourcePlatform':
							_this.ingest.setDataValue('source', 'platform', value);
							break;
						default:
							console.log('Invalid key for Apps Service');
							break;
					}
				}
			});
			// setting the client id to distinguish between clients.
			var imsTokenPayload = _CommonUtil2.default.extractPayloadFromToken(_GlobalData2.default.accessToken);
			if (imsTokenPayload) {
				this.ingest.setDataValue('source', 'client_id', imsTokenPayload.client_id);
			}
			this.ingest.setDataValue('event', 'pagename', document.title);

			this.ingest.addToCollection();
		}

		/**
   * [replaceSpaces replace spaces with dashes]
   * @param  {[string]} text
   * @return {[string]}  modified text
   */

	}, {
		key: 'replaceSpaces',
		value: function replaceSpaces(text) {

			var newVal = text;

			newVal = newVal.replace(/\s+/g, '-');

			// if the first char is now a '-', get rid of it
			if (newVal.length && newVal.charAt(0) === '-') {
				newVal = newVal.substr(1);
			}

			return newVal;
		}
	}, {
		key: 'addToCollectionAndSendEvent',
		value: function addToCollectionAndSendEvent(dataObject) {
			if (_GlobalData2.default.analyticsParams) {
				Object.assign(dataObject, _GlobalData2.default.analyticsParams);
			}
			this.addToCollection(dataObject);
			this.sendToIngest();
		}
	}, {
		key: 'trackTimeOnCompletion',
		value: function trackTimeOnCompletion(timetaken, subtype, result) {
			this.getIngestObject();
			var dataObject = {
				setEventType: 'wamWF',
				setEventValue: result,
				setEventCount: timetaken,
				setEventSubtype: subtype,
				setEventGUID: _uuid2.default.v4(),
				setEventOffline: false,
				setUIViewType: 'App Inline'
			};

			this.addToCollectionAndSendEvent(dataObject);
		}
	}, {
		key: 'sendAnalyticsOnCCDDetection',
		value: function sendAnalyticsOnCCDDetection(isCCDPresent, timetaken, env) {
			this.getIngestObject(env);
			var dataObject = {
				setEventType: 'ccd-detect',
				setEventValue: timetaken,
				setEventSubtype: _WAMConstants.analyticsEvents.trackTime.ccdDetectTimeTaken,
				setContentName: isCCDPresent ? 'ccd-present' : 'ccd-not-present',
				setEventGUID: _uuid2.default.v4(),
				setEventOffline: false,
				setUIViewType: 'App Inline'
			};
			this.addToCollectionAndSendEvent(dataObject);
		}
	}, {
		key: 'sendAnalyticsOnCCDFailedWAM',
		value: function sendAnalyticsOnCCDFailedWAM() {
			this.getIngestObject();
			var dataObject = {
				setEventType: 'wamWF',
				setEventSubtype: 'ccd-failed-wam',
				setEventGUID: _uuid2.default.v4(),
				setEventOffline: false,
				setUIViewType: 'App Inline'
			};

			this.addToCollectionAndSendEvent(dataObject);
		}
	}, {
		key: 'sendAnalytics',
		value: function sendAnalytics(analyticsConfig) {
			var _this2 = this;

			var sendAnalyticsForWAMWFIdentification = function sendAnalyticsForWAMWFIdentification(analyticsConfig) {
				var dataObject = {
					setEventType: analyticsConfig.eventName,
					setEventSubtype: analyticsConfig.subType,
					setFrameworkName: analyticsConfig.workflow,
					setEventGUID: _uuid2.default.v4(),
					setEventOffline: false,
					setUIViewType: 'App Inline'
				};
				_this2.addToCollectionAndSendEvent(dataObject);
			};

			var sendAnalyticsOnWAMConnection = function sendAnalyticsOnWAMConnection(analyticsConfig) {
				var dataObject = {
					setEventType: 'api',
					setEventValue: analyticsConfig.status,
					setEventSubtype: 'wam',
					setEventGUID: _uuid2.default.v4(),
					setErrorType: analyticsConfig.errorType,
					setErrorDesc: analyticsConfig.errorDesc,
					setEventOffline: false,
					setUIViewType: 'App Inline'
				};
				_this2.addToCollectionAndSendEvent(dataObject);
			};

			var sendAnalyticsOnGetCurrentDevice = function sendAnalyticsOnGetCurrentDevice(analyticsConfig) {

				var dataObject = {
					setEventType: 'api',
					setEventValue: analyticsConfig.status,
					setEventSubtype: 'get-current-device',
					setEventGUID: _uuid2.default.v4(),
					setEventOffline: false,
					setUIViewType: 'App Inline'
				};
				_this2.addToCollectionAndSendEvent(dataObject);
			};

			var sendAnalyticsOnThorDetection = function sendAnalyticsOnThorDetection(analyticsConfig) {
				var dataObject = {
					setEventType: 'detect',
					setEventValue: analyticsConfig.status,
					setEventSubtype: 'thor',
					setEventGUID: _uuid2.default.v4(),
					setEventOffline: false,
					setUIViewType: 'App Inline'
				};
				_this2.addToCollectionAndSendEvent(dataObject);
			};

			var sendAnalyticsOnReceiveCurrentDevice = function sendAnalyticsOnReceiveCurrentDevice(analyticsConfig) {
				var dataObject = {
					setEventType: 'api',
					setEventValue: analyticsConfig.status,
					setEventSubtype: 'receive-device-id',
					setEventGUID: _uuid2.default.v4(),
					setErrorType: analyticsConfig.errorType,
					setErrorDesc: analyticsConfig.errorDesc,
					setEventOffline: false,
					setUIViewType: 'App Inline'
				};
				_this2.addToCollectionAndSendEvent(dataObject);
			};

			var sendAnalyticsOnRegistrationWithWAM = function sendAnalyticsOnRegistrationWithWAM(analyticsConfig) {
				var dataObject = {
					setEventType: 'api',
					setEventValue: analyticsConfig.status,
					setEventSubtype: 'cch-registration-wam',
					setEventGUID: _uuid2.default.v4(),
					setErrorType: analyticsConfig.errorType,
					setErrorDesc: analyticsConfig.errorDesc,
					setEventOffline: false,
					setUIViewType: 'App Inline'
				};
				_this2.addToCollectionAndSendEvent(dataObject);
			};

			var sendAnalyticsOnReceiveThorAppsState = function sendAnalyticsOnReceiveThorAppsState(analyticsConfig) {
				var dataObject = {
					setEventType: 'api',
					setEventValue: analyticsConfig.status,
					setEventSubtype: 'thor-apps-state',
					setEventGUID: _uuid2.default.v4(),
					setErrorType: analyticsConfig.errorType,
					setErrorDesc: analyticsConfig.errorDesc,
					setEventOffline: false,
					setUIViewType: 'App Inline'
				};
				_this2.addToCollectionAndSendEvent(dataObject);
			};

			var sendAnalyticsOnCommandProgress = function sendAnalyticsOnCommandProgress(analyticsConfig) {
				var dataObject = {
					setEventType: analyticsConfig.commandName,
					setEventValue: analyticsConfig.eventValue,
					setEventSubtype: analyticsConfig.commandStage,
					setEventGUID: _uuid2.default.v4(),
					setEventOffline: false,
					setUIViewType: 'App Inline:Install',
					setContentID: analyticsConfig.sapcode,
					setContentName: analyticsConfig.sapcode,
					setContentCategory: 'desktop',
					setContentExtension: analyticsConfig.version
				};
				_this2.addToCollectionAndSendEvent(dataObject);
			};

			var isClientDefinedAnalytics = false;
			if (_GlobalData2.default.callbacks.analyticsCallbacks) {
				_GlobalData2.default.callbacks.analyticsCallbacks.forEach(function (analyticsCallback) {
					if (analyticsCallback[analyticsConfig.eventName]) {
						analyticsCallback[analyticsConfig.eventName](analyticsConfig);
						isClientDefinedAnalytics = true;
					}
				});
			}
			if (!isClientDefinedAnalytics) {
				this.getIngestObject();
				switch (analyticsConfig.eventName) {
					case _WAMConstants.analyticsEvents.v2ToV1:
					case _WAMConstants.analyticsEvents.v1ToV2:
						sendAnalyticsForWAMWFIdentification(analyticsConfig);
						break;
					case _WAMConstants.analyticsEvents.onClientWAMConnection:
						sendAnalyticsOnWAMConnection(analyticsConfig);
						break;
					case _WAMConstants.analyticsEvents.onGetCurrentDevice:
						sendAnalyticsOnGetCurrentDevice(analyticsConfig);
						break;
					case _WAMConstants.analyticsEvents.onThorDetectionByClient:
						sendAnalyticsOnThorDetection(analyticsConfig);
						break;
					case _WAMConstants.analyticsEvents.onReceiveCurrentDevice:
						sendAnalyticsOnReceiveCurrentDevice(analyticsConfig);
						break;
					case _WAMConstants.analyticsEvents.onClientRegistratonWithWAM:
						sendAnalyticsOnRegistrationWithWAM(analyticsConfig);
						break;
					case _WAMConstants.analyticsEvents.onClientRecvThorAppsState:
						sendAnalyticsOnReceiveThorAppsState(analyticsConfig);
						break;
					case _WAMConstants.analyticsEvents.onCommandProgress:
					case _WAMConstants.analyticsEvents.onAppUnknown:
						sendAnalyticsOnCommandProgress(analyticsConfig);
						break;
				}
			}
		}
	}]);

	return AnalyticsUtil;
}();

exports.default = new AnalyticsUtil();